module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcontractors.net.au/images/our_services_1-8f765e5df209cd897ad958a152235fb3.jpg";